import { useNavigate } from "react-router-dom";

/**
 * Renders caption text with clickable #AdETags and @mentions.
 * #tag → amber/gold link → navigates to /app/explore/tag/{tag}
 * @mention → blue link → navigates to user search (by name)
 */
export const CaptionRenderer = ({ text, className = "" }) => {
  const navigate = useNavigate();

  if (!text) return null;

  // Split text by #tags and @mentions, keeping delimiters
  const parts = text.split(/(#\w+|@\w+)/g);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (part.startsWith("#")) {
          const tag = part.slice(1);
          return (
            <span
              key={i}
              className="text-amber-600 dark:text-amber-400 font-semibold cursor-pointer hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/app/explore/${tag}`);
              }}
              data-testid={`adetag-${tag}`}
            >
              {part}
            </span>
          );
        }
        if (part.startsWith("@")) {
          const mention = part.slice(1);
          return (
            <span
              key={i}
              className="text-blue-500 dark:text-blue-400 font-semibold cursor-pointer hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/app/mention/${mention}`);
              }}
              data-testid={`mention-${mention}`}
            >
              {part}
            </span>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
};

export default CaptionRenderer;
